import React from 'react';
import Fade from 'react-reveal/Fade';
import ImpactStats from '../fakeData/ImpactStats';
import './../index.css';

const Impact = () => {
  return (
    <section className='impact-container' data-aos='fade-up'>
      <div className='container'>
        <div className='row impact-row'>
          {ImpactStats.map((stat) => (
            <Fade bottom key={stat.id}>
              <div className='impact-item'>
                <h2 className='impact-value'>{stat.value}</h2>
                <p className='impact-label'>{stat.label}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
